import React from "react";
const IconFilters = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 13.5L18 13.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M11 6.5L2 6.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M2 13.5H4" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M18 6.5L16 6.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <circle
      cx="2.5"
      cy="2.5"
      r="2.5"
      transform="matrix(1 0 0 -1 10.5 9)"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <circle
      cx="2.5"
      cy="2.5"
      r="2.5"
      transform="matrix(1 0 0 -1 4.5 16)"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconFilters;
